<div class="main-content">
  <mat-form-field class="form-content">
    <input [(ngModel)]="filterValue" matInput (keyup)="onFilterChange($event)" />
    <mat-label>Filter</mat-label>
  </mat-form-field>
  <div class="item">
    <div><mat-slide-toggle [(ngModel)]="availableOnly" (ngModelChange)="onAvailableChange()"></mat-slide-toggle></div>
    <mat-label>Available</mat-label>
  </div>
  <div class="item">
    <div><mat-slide-toggle [(ngModel)]="inactiveOnly" (ngModelChange)="onInactiveChange()"></mat-slide-toggle></div>
    <mat-label>Inactive</mat-label>
  </div>
</div>
@if (dataSource) {
  <div class="data-content">
    @for (country of dataSource.filteredData; track country) {
      <div
        class="main-container"
        [ngStyle]="{ backgroundColor: country.available ? 'rgba(60,160,60, 0.5)' : 'rgba(160, 60, 60, 0.5)' }">
        <div>
          @if (country.mode === 'COUNTRY') {
            <div class="item">{{ emoji(country) }} {{ country.countryName }}</div>
          }
          @if (country.mode === 'ENTITY') {
            <div class="item">{{ country.entityName }}</div>
          }
          @for (r of country.restrictionReason; track r) {
            <div>
              <b>{{ r }}</b>
            </div>
          }
          @if (!country.restrictionReason || country.restrictionReason.length === 0) {
            <div>
              <b>Available</b>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
